import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { OeAppPersonService } from '../../../../shared/oe-app-person.service';
import { OeAppService } from '../../../../shared/oe-app.service';
import { LiveClassLessonTrack } from '../../live-class-lesson-track-dto';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Injectable({
  providedIn: 'root',
})
export class PrivateClassTrackService {
  private privateClassTrackCache$: Observable<LiveClassLessonTrack>;

  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  getPrivateClassTrack(): Observable<LiveClassLessonTrack> {
    if (!this.privateClassTrackCache$) {
      this.privateClassTrackCache$ = this.http
        .get<LiveClassLessonTrack>(
          `${this.oeAppService.courseServiceHost}/v1/liveclasslesson-tracks/select?contactId=${
            this.oeAppPersonService.contactId
          }`
        )
        .pipe(
          map((track) => ({
            ...track,
            image: `//${this.oeAppService.s3BucketHost()}/production/private-classes/assets/images/${track.uuid}.jpg`,
          })),
          shareReplay(1)
        );
    }
    return this.privateClassTrackCache$;
  }

  getPrivateClassLessons(lessonTrackUuid: string, showFreeFormLesson = false) {
    return this.http.get<Array<PrivateClassLesson>>(
      `${this.oeAppService.courseServiceHost}/v1/liveclasslessons?contactId=${
        this.oeAppPersonService.contactId
      }&lessonTrackUuid=${lessonTrackUuid}&forTeacher=false&showFreeFormLesson=${showFreeFormLesson}`
    );
  }

  getPrivateClassLessonsWithFreeFormTopic(lessonTrackUuid: string) {
    return this.getPrivateClassLessons(lessonTrackUuid, true);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-track/private-class-track.service.ts